<template>
  <div>

    <v-alert
      prominent
      type="warning"
      icon="mdi-map-marker-question-outline"
      v-if="isAdmin"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ $t("forms.info.warningDirectEdit") }}
        </v-col>
        <v-col class="shrink">
          <v-btn
            to="/manage/edit/researchers"
          >
            <v-icon
              left
              dark
            >
              mdi-arrow-right-circle
            </v-icon>
            {{ $t("forms.info.gotoDirectEdit") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <PendingUserForms
      v-if="pendingForms.length"
      :title="$t('table.investigator.pendingForms')"
      :items="pendingForms"
    />

    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
                class="text-left"
              >
                <v-list-item :to="form.path">
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="filteredInvestigators"
      :search="search"
      class="elevation-1 table-cursor-hand mt-4"
      :items-per-page="30"
      :custom-filter="filterItems"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      sort-by="preferred_name.given_name"
      @click:row="clickRow"
      :loading="loading"
      :loading-text="$t('table.loading')"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer />
          <v-menu offset-y class="mr-2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :outlined="filters.oldpeople != null"
                  :text="filters.oldpeople == null"
                  v-bind="attrs"
                  v-on="on"
                  class="mx-0 mx-lg-2"
                >
                  <template
                    v-if="filters.oldpeople == null"
                  >
                    <v-icon>mdi-account-group</v-icon>
                    <span class="d-none d-md-inline">
                      {{ $t('table.tooltip.oldpeople_everyone') }}
                    </span>
                  </template>
                  <template
                    v-else-if="filters.oldpeople == 'newpeople'"
                  >
                    <v-icon>mdi-account-multiple</v-icon>
                    <span class="d-none d-md-inline">
                      {{ $t('table.tooltip.oldpeople_newpeople') }}
                    </span>
                  </template>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="filters.oldpeople = 'newpeople' ; dropdownFilters('oldpeople', 'newpeople');"
                  v-if="filters.oldpeople != 'newpeople'"
                  link
                >
                  <v-list-item-title>
                    <v-icon
                    >
                      mdi-account-multiple
                    </v-icon>
                    {{ $t('table.tooltip.oldpeople_newpeople') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="filters.oldpeople = null ; dropdownFilters('oldpeople', null);"
                  v-if="filters.oldpeople != null"
                  link
                >
                  <v-list-item-title>
                    <v-icon
                    >
                      mdi-account-group
                    </v-icon>
                    {{ $t('table.tooltip.oldpeople_everyone') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-toolbar>
      </template>
      <template v-slot:item.preferred_name.given_name="{ item }"
        >{{ item.preferred_name.given_name }}
        {{ item.preferred_name.family_name }}</template
      >
      <template v-slot:item.account.activation_status="{ item }">
        <v-tooltip
          v-if="item.account === null || item.account.activation_status === false"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red"
              v-bind="attrs"
              v-on="on"
            >
              mdi-lock
            </v-icon>
          </template>
          {{ $t('table.tooltip.account_locked') }}
        </v-tooltip>
        <v-tooltip
          v-else-if="item.account !== null && item.account.expiration_date !== null && item.account.expires_soon === true"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="orange"
              v-bind="attrs"
              v-on="on"
            >
              mdi-lock-clock
            </v-icon>
          </template>
          {{ $t('table.tooltip.account_warn') }}
        </v-tooltip>
        <v-tooltip
          v-else
          top
        >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="green"
            v-bind="attrs"
            v-on="on"
          >
            mdi-lock-open
          </v-icon>
        </template>
        {{ $t('table.tooltip.account_unlocked') }}
      </v-tooltip>
    </template>
      <template v-slot:item.vinculation="{ item }">
        <div class="center">
        <v-tooltip
          v-if="
            item.vinculation !== null &&
            (item.vinculation.end_date === null ||
              new Date(item.vinculation.end_date).getTime() >
                new Date().getTime() + 24*31*60*60*1000)
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="green"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-check
            </v-icon>
          </template>
          {{ $t('table.tooltip.vinculation_ok') }}
        </v-tooltip>
        <v-tooltip
          v-else-if="
            item.vinculation !== null &&
            (item.vinculation.end_date === null ||
              new Date(item.vinculation.end_date).getTime() >
                new Date().getTime())
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="orange"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-clock
            </v-icon>
          </template>
          {{ $t('table.tooltip.vinculation_warn') }}
        </v-tooltip>
        <v-tooltip
          v-else-if="
            item.vinculation === null
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-remove
            </v-icon>
          </template>
          {{ $t('table.tooltip.vinculation_no') }}
        </v-tooltip>
        <v-tooltip
          v-else
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-alert
            </v-icon>
          </template>
          {{ $t('table.tooltip.vinculation_expired') }}
        </v-tooltip>
      </div>
      </template>
      <template v-slot:item.last_workplace_assignation="{ item }">
        <div class="center">
        <v-tooltip
          v-if="
            item.last_workplace_assignation !== null &&
            (item.last_workplace_assignation.expiration_date === null ||
              new Date(item.last_workplace_assignation.expiration_date).getTime() >
                new Date().getTime() + 24*31*60*60*1000)
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="green"
              v-bind="attrs"
              v-on="on"
            >
              mdi-archive-check
            </v-icon>
          </template>
          {{ $t('table.tooltip.workplace_ok') }}
        </v-tooltip>
        <v-tooltip
          v-else-if="
            item.last_workplace_assignation !== null &&
            (item.last_workplace_assignation.expiration_date === null ||
              new Date(item.last_workplace_assignation.expiration_date).getTime() >
                new Date().getTime())
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="orange"
              v-bind="attrs"
              v-on="on"
            >
              mdi-archive-clock
            </v-icon>
          </template>
          {{ $t('table.tooltip.workplace_warn') }}
        </v-tooltip>
        <v-tooltip
          v-else-if="
            item.last_workplace_assignation === null
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              v-bind="attrs"
              v-on="on"
            >
              mdi-archive-remove
            </v-icon>
          </template>
          {{ $t('table.tooltip.workplace_no') }}
        </v-tooltip>
        <v-tooltip
          v-else
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red"
              v-bind="attrs"
              v-on="on"
            >
              mdi-archive-alert
            </v-icon>
          </template>
          {{ $t('table.tooltip.workplace_expired') }}
        </v-tooltip>
      </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "../forms/PendingUserForms";
export default {
  components: { PendingUserForms },
  data: () => ({
    pendingForms: [{}],
    loading: true,
    search: "",
    filters:{
      oldpeople: null
    },
    investigators: [],
    filteredInvestigators: [],
    forms: [
      {
        icon: "mdi-plus",
        title: "investigator.forms.newResearcher",
        path: "/my-forms/researcher/newResearcher"
      },
      {
        icon: "mdi-account-plus",
        title: "investigator.forms.newExternal",
        path: "/my-forms/researcher/newExternal"
      }
    ]
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.givenAndFamilyName"),
          value: "preferred_name.given_name",
        },
        { text: this.$t("form.email"),
          value: "email[0]",
        },
        {
          text: this.$t("table.account"),
          value: "account.activation_status",
          width: "15%",
          align: 'center',
        },
        {
          text: this.$t("table.vinculation"),
          value: "vinculation",
          width: "15%",
          align: 'center',
        },
        {
          text: this.$t("table.workplace"),
          value: "last_workplace_assignation",
          width: "15%",
          align: 'center',
        }
      ];
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/user/persons_incharge";
      axios
        .get(path)
        .then(response => {
          this.investigators = this.filteredInvestigators = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });

      path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/pending/investigator";
      axios
        .get(path)
        .then(response => {
          this.pendingForms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    filterItems(value, search, item) {
      const search_value = search
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      const customValue = (
        item.preferred_name.given_name +
        " " +
        item.preferred_name.family_name
      )
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const document = item.id_number["value"].toString().toLowerCase();
      return (
        customValue != null &&
        search_value != null &&
        typeof customValue === "string" &&
        (customValue.indexOf(search_value) !== -1 ||
          document.indexOf(search_value) !== -1)
      );
    },

    dropdownFilters(currentFilter, v, pool = this.investigators, recurse = true){
      if(currentFilter == "oldpeople"){
        if(v == null){
          this.filteredInvestigators = pool;
        }
        else if(v == "newpeople"){
          this.filteredInvestigators = pool.filter((item) => (item.vinculation_status.very_old_vinculation === false || item.account_status.very_old_account === false));
        }
      }
    },

    clickRow(item) {
      this.$router.push({ path: `/researchers/${item.id}` });
    }
  }
};
</script>
